import { React, useState } from "react";
import PropTypes from "prop-types";
import FormAccordion from "../../../components/Form/FormAccordion";
import ContentSidebar from "./ContentSidebar";
import {
	InputField,
	TextAreaField,
} from "../../../components/Form/FormComponents";
import Chapters from "./Chapters";
import { getFormattedDate } from "../../../utils/DateUtils";

// eslint-disable-next-line no-unused-vars
function SingleVideoForm({ data, setEducationData }) {
	const [formData, setFormData] = useState(data);

	// console.log(data);

	const handleInputChange = (e) => {
		setFormData({ ...formData, [e.target.name]: e.target.value });
	};
	return (
		<form className='leaseForm'>
			<ContentSidebar contentData={formData}
			type={'video'} />
			<div className='RightSection'>
				<FormAccordion title='Video Information' open={true}>
					<div className='grid grid-cols-3 gap-3'>
						<div className='form-group'>
							<label>DATE / TIME</label>
							<InputField
								name='createdAt'
								handleChange={handleInputChange}
								value={getFormattedDate(formData?.createdAt)}
							/>
						</div>

						<div className='form-group'>
							<label>TITLE</label>
							<InputField
								name='name'
								handleChange={handleInputChange}
								value={formData?.name}
							/>
						</div>

						<div className='form-group'>
							<label>DURATION</label>
							<InputField
								name='duration'
								handleChange={handleInputChange}
								value={formData?.totalDuration}
							/>
						</div>

						<div className='form-group'>
							<label>CATEGORY</label>
							<InputField
								name='category'
								handleChange={handleInputChange}
								value={formData?.category}
							/>
						</div>

						<div className='form-group'>
							<label>NUMBER OF VIEWS</label>
							<InputField
								name='views'
								handleChange={handleInputChange}
								value={formData?.views}
							/>
						</div>

						<div className='form-group'>
							<label>CHAPTERS</label>
							<InputField
								name='chapters'
								handleChange={handleInputChange}
								value={formData?.chapters?.length || "single chapter"}
							/>
						</div>
					</div>
				</FormAccordion>

				<FormAccordion title='Video description'>
					<div className='form-group'>
						<TextAreaField name='description' value={formData?.description} />
					</div>
				</FormAccordion>

				<FormAccordion title='Chapters'>
					<div className='form-group'>
            {formData?.chapters?.length > 0 ? formData.chapters.map((data,index)=>{
              return <Chapters data={data}   type={"video"} key={index}  />
            }) :  <Chapters  data={formData}   type={"video"} />}
						
					</div>
				</FormAccordion>
			</div>
		</form>
	);
}

SingleVideoForm.propTypes = {
	data: PropTypes.object,
	setEducationData: PropTypes.func,
};

export default SingleVideoForm;
